import React from 'react';
import { Link } from 'react-router-dom';
import { FolderOpen } from 'lucide-react';
import { createPageUrl } from '../../utils';

interface Debtor {
  id: number;
  full_name: string;
  cif: string;
  document_status: 'complete' | 'incomplete' | 'expired';
}

interface DebtorRecentListProps {
  debtors: Debtor[];
}

export default function DebtorRecentList({ debtors }: DebtorRecentListProps) {
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'complete':
        return 'bg-green-100 text-green-700';
      case 'expired':
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-yellow-100 text-yellow-700';
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'complete':
        return 'Lengkap';
      case 'expired':
        return 'Kadaluarsa';
      default:
        return 'Tidak Lengkap';
    }
  };

  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <div className="p-4 border-b flex items-center justify-between">
        <h3 className="text-lg font-semibold">Debitur Terbaru</h3>
        <Link to={createPageUrl('DebtorList')}>
          <button className="text-sm text-amber-600 hover:text-amber-700 font-medium">
            Lihat Semua
          </button>
        </Link>
      </div>
      <div className="p-4">
        {debtors.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <FolderOpen className="w-12 h-12 mx-auto mb-3 text-gray-300" />
            <p>Belum ada data debitur</p>
          </div>
        ) : (
          <div className="space-y-3">
            {debtors.map(debtor => (
              <Link key={debtor.id} to={createPageUrl(`DebtorDetail?id=${debtor.id}`)}>
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                      <span className="font-semibold text-amber-700">
                        {debtor.full_name?.charAt(0) || 'D'}
                      </span>
                    </div>
                    <div>
                      <p className="font-medium text-sm">{debtor.full_name}</p>
                      <p className="text-xs text-gray-500">CIF: {debtor.cif || '-'}</p>
                    </div>
                  </div>
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusBadge(debtor.document_status)}`}
                  >
                    {getStatusLabel(debtor.document_status)}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
